import Crud from '../views/Cbo/Crud'
import Entity from '../views/Cbo/Add'

let routes = {
    path: '/cbos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cbos/add',
            name: 'NewCbo',
            component: Entity,
            meta: {
                pageTitle: 'Cbo',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Cbo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cbos/edit/:id?',
            name: 'EditCbo',
            component: Entity,
            meta: {
                pageTitle: 'Cbo',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Cbo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/cbos',
            name: 'list-cbos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de CBOs',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'CBOs',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
